// Typed wrappers around react-admin i18n hooks.
//
// `useT()` constrains the key argument to the dot-paths derived from the
// English source-of-truth dictionary, giving us IDE autocomplete and
// build-time errors for typos or missing translations.

import { useTranslate, useLocaleState } from 'react-admin';
import { useCallback } from 'react';
import { persistLocale, type AppLocale } from './i18nProvider';
import type { AppTranslationKey } from './types';

export type TranslateOptions = Record<string, any> & { smart_count?: number };

export const useT = () => {
    const translate = useTranslate();
    return useCallback(
        (key: AppTranslationKey, options?: TranslateOptions) => translate(key, options),
        [translate]
    );
};

export const useAppLocale = (): [AppLocale, (locale: AppLocale) => void] => {
    const [locale, setLocale] = useLocaleState();
    const change = useCallback(
        (next: AppLocale) => {
            persistLocale(next);
            setLocale(next);
        },
        [setLocale]
    );
    return [locale as AppLocale, change];
};
